import { $, $$ } from 'utils/dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { fadeInFromBottom } from '../animations';
import { viewport } from '../getViewport';

export const storySection = () => {
  const sections = $$('.story-section');

  if (sections.length) {
    sections.forEach(section => {
      const sectionHeading = $('.story-section__header', section);
      const sectionHero = $('.story-section__hero', section);

      if (!sectionHeading && !sectionHero) return;

      const timeline = gsap.timeline();

      if (sectionHeading) {
        gsap.set(sectionHeading, { y: viewport.isReduced ? 0 : 200 });

        timeline.to(sectionHeading, {
          y: 0,
        });
      }

      if (sectionHero) {
        gsap.set(sectionHero, {
          '--filter-value': viewport.isReduced ? '1' : '3',
          scale: viewport.isReduced ? 1 : 0.6,
          y: viewport.isReduced ? 0 : 100,
        });

        timeline.to(
          sectionHero,
          {
            scale: 1,
            '--filter-value': () => 1,
            y: 0,
          },
          '<+=10%'
        );
      }

      ScrollTrigger.create({
        animation: timeline,
        trigger: section,
        start: () => 'top 95%',
        end: () => 'top 30%',
        toggleActions: 'play pause resume reset',
        scrub: 1,
      });
    });

    fadeInFromBottom($$('.story-section__hero-text-inner'));

    fadeInFromBottom(
      $$('.story-section__text:not(.story-section__text--left-right')
    );

    fadeInFromBottom($$('.story .image'));

    const animateLeftRightText = elements => {
      elements.forEach((element, index) => {
        if (index % 2 === 0) {
          gsap.set(element, {
            x: viewport.isReduced
              ? 0
              : viewport.isDesktop
              ? -30
              : viewport.isTablet
              ? -30
              : viewport.isMobile
              ? -15
              : '',
          });
        } else {
          gsap.set(element, { x: viewport.isReduced ? 0 : 30 });
        }

        const timeline = gsap.timeline();
        timeline.to(element, { x: 0 });

        ScrollTrigger.create({
          animation: timeline,
          trigger: element,
          start: () => 'top 90%',
          end: () => 'top top',
          toggleActions: 'play pause resume reverse',
        });
      });
    };

    animateLeftRightText($$('.story-section__text--left-right p'));

    // the following code plays image single frames. needs refactor

    const frameCount = 11;
    const getOffsetValue = () => {
      const value = viewport.isDesktop
        ? 688
        : viewport.isTablet
        ? 688
        : viewport.isMobile
        ? 342
        : '';
      return -value;
    };

    const scrollImageBrain = $('.story-section__scroll-image-brain');
    const scrollImage = $('.story-section__scroll-image');

    if (scrollImageBrain && scrollImage) {
      gsap.to(scrollImageBrain, {
        marginLeft: viewport.isReduced
          ? ''
          : getOffsetValue() * frameCount + 'px',
        ease: 'steps(' + frameCount + ')',
        repeat: -1,
        duration: 10,
        scrollTrigger: {
          trigger: scrollImage,
          start: () => 'top 75%',
          end: () => 'bottom top',
        },
      });
    }

    const storyImage = $('.story-section__image');

    if (storyImage) {
      const getImageContainerWidth = () => {
        const value = storyImage.offsetWidth;
        return -value;
      };

      const frameCount2 = 6;
      const offsetValue = getImageContainerWidth();

      gsap.to('.story-section__image-car', {
        marginLeft: viewport.isReduced ? 0 : offsetValue * frameCount2 + 'px',
        ease: 'steps(' + frameCount2 + ')',
        repeat: -1,
        duration: 3,
        scrollTrigger: {
          trigger: storyImage,
          start: () => 'top bottom',
          end: () => 'bottom top',
        },
      });
    }
  }
};
